import { Achievement } from '@/shared/types';

export const achievements: Achievement[] = [
  { metric: '80%', label: 'Faster Data Analysis', context: 'via an automated Python pipeline' },
  { metric: '98%', label: 'Robot Fleet Uptime', context: 'across a 10-unit Starship fleet' },
  { metric: '20%', label: 'Higher Test Throughput', context: 'at Daktronics product engineering' },
];
